import toastr from "toastr"
import { getCurrentInstance } from "vue"
import { BvToastOptions } from "bootstrap-vue"

export const useNotification = () => {
  const app = getCurrentInstance()
  const notifyError = (message: string, options?: BvToastOptions) => {
    app.proxy.$root.$bvToast.toast(message, {variant: 'danger', title: 'Error', ...options})
  }
  const notifyInfo = (message: string, options?: BvToastOptions) => {
    app.proxy.$root.$bvToast.toast(message, {variant: 'primary', title: 'Info', ...options})
  }
  const notifySuccess = (message: string, options?: BvToastOptions) => {
    app.proxy.$root.$bvToast.toast(message, {variant: 'success', title: 'Success',...options})
  }
  const notifyWarning = (message: string, options?: BvToastOptions) => {
    app.proxy.$root.$bvToast.toast(message, {variant: 'warning', title: 'Warning', ...options})
  }
  return {toastr, notifyError, notifySuccess, notifyWarning, notifyInfo}
}
